/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  GrantFeatureAccessMutationRequest,
  GrantFeatureAccessMutationResponse,
} from "../types/GrantFeatureAccess.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const grantFeatureAccessMutationKey = () =>
  [{ url: "/v1/access-management/grant-feature-access" }] as const

export type GrantFeatureAccessMutationKey = ReturnType<
  typeof grantFeatureAccessMutationKey
>

/**
 * @summary Grant feature access
 * {@link /v1/access-management/grant-feature-access}
 */
export async function grantFeatureAccess(
  data: GrantFeatureAccessMutationRequest,
  config: Partial<RequestConfig<GrantFeatureAccessMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    GrantFeatureAccessMutationResponse,
    ResponseErrorConfig<Error>,
    GrantFeatureAccessMutationRequest
  >({
    method: "POST",
    url: `/v1/access-management/grant-feature-access`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function grantFeatureAccessMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<GrantFeatureAccessMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = grantFeatureAccessMutationKey()
  return mutationOptions<
    ResponseConfig<GrantFeatureAccessMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: GrantFeatureAccessMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return grantFeatureAccess(data, config)
    },
  })
}

/**
 * @summary Grant feature access
 * {@link /v1/access-management/grant-feature-access}
 */
export function useGrantFeatureAccess<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<GrantFeatureAccessMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: GrantFeatureAccessMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<GrantFeatureAccessMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? grantFeatureAccessMutationKey()

  const baseOptions = grantFeatureAccessMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<GrantFeatureAccessMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: GrantFeatureAccessMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<GrantFeatureAccessMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: GrantFeatureAccessMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<GrantFeatureAccessMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: GrantFeatureAccessMutationRequest },
    TContext
  >
}
